window.dataLayer = window.dataLayer || [];

if (!window.__analyticHandlers) {
    window.__analyticHandlers = {
        handlePageLoad: () => {},
        handleSkinAdvisorAddToCart: () => {},
        handleSkinAdvisorError: () => {},
        handleFacetCheck: () => {},
        handleChosenCategory: () => {},
        handleChosenProduct: () => {},
        handleChosenKeyword: () => {},
        handleChosenArticle: () => {},
        handleChosenRecentSearch: () => {},
        handleChosenPopularSearch: () => {},
        handleChosenBrand: () => {},
        handleSearch: () => {},
        handleSearchRegular: () => {},
        handleSearchStart: () => {},
        handleSearchResultsClick: () => {},
        handleLogin: () => {},
        handleRegistration: () => {},
        handleRegistrationStep: () => {},
        handleRegistrationStepComplete: () => {},
        handleRegistrationLoyaltyOption: () => {},
        handleCheckoutRegistration: () => {},
        handleCheckoutAsGuest: () => {},
        handleAddToCart: () => {},
        handleApplyBMVoucher: () => {},
        handleThumbnail: () => {},
        handleRemoveFromCart: () => {},
        handleUpdateCart: () => {},
        handleCheckout: () => {},
        handleSelectDeliveryMethod: () => {},
        handleSelectPaymentMethod: () => {},
        handleGiftCardPayment: () => {},
        handleOrderPlaced: () => {},
        handleLinkClick: () => {},
        handleClick: () => {},
        handleView: () => {},
        handleActionButtonClick: () => {},
        handleViewModifaceButton: () => {},
        handleClickOpenModifacePopup: () => {},
        handleChooseModifaceMode: () => {},
        handleTransaction: () => {},
        handleSetCustomerProfile: () => {},
        handleTermsChange: () => {},
        handleClickAddToWishlist: () => {},
        handleAddToWishlist: () => {},
        handleOutboundLinks: () => {},
        handleCreateAccount: () => {},
        handleCheckGiftCardBalance: () => {},
        handleProductImpressions: () => {},
        handleProductImpressionClick: () => {},
        handlePromoImpressions: () => {},
        handlePromoImpressionClick: () => {},
        handleLinkLoyaltyCard: () => {},
        handlePrivacySettingsLoading: () => {},
        handlePrivacySettingsSubmit: () => {},
        handlePrivacySettingsComplete: () => {},
        handleCheckoutOptions: () => {},
        handleCheckoutStep: () => {},
        handleReviewProduct: () => {},
        handleReviewAbandoned: () => {},
        handleReviewError: () => {},
        handleReviewReactions: () => {},
        handleReviewsImpressionView: () => {},
        handleNewsletterSubscriptionLoading: () => {},
        handleNewsletterSubscriptionSubmit: () => {},
        handleNewsletterSubscriptionConfirmation: () => {},
        handleCarouselArrowClick: () => {},
        handleTileAddToCart: () => {},
        handlePDPReviewFilters: () => {},
        CustomerRegistrationEvent: () => {},
        handleLoyaltyCardRegistrationEvent: () => {},
        handleSelectedCategory: () => {},
        handlePromoAddSubmitEvent: () => {},
        handlePromoAddStartEvent: () => {},
        handlePromoAddErrorEvent: () => {},
        handlePromoAddConfirmEvent: () => {},
        handleLoginCheckoutPageLoadedEvent: () => {},
        handleSelectLoginOptionEvent: () => {},
        handleCheckoutExisting: () => {},
        handleFailedCheckoutAuth: () => {},
        handleSearchboxToggle: () => {},
        handleViewSearchResultsEvent: () => {},
        handleOnlineSearch: () => {},
        handleDeliveryOption: () => {},
        handlePaymentOption: () => {},
        handlePromoRemoveEvent: () => {},
        handleGiftWrappingStartEvent: () => {},
        handleGiftWrappingConfirmEvent: () => {},
        handleGiftWrappingAbortEvent: () => {},
        handleGiftSampleStartEvent: () => {},
        handleGiftSampleConfirmEvent: () => {},
        handleGiftSampleAbortEvent: () => {},
        handleGiftSampleRemoveEvent: () => {},
        handleStartLoginEvent: () => {},
        handleSubmitLoginEvent: () => {},
        handleCompleteLoginEvent: () => {},
        handleCheckStockStorageEvent: () => {},
        handleOutOfStockErrorForCC: () => {},
        handleAddToCartFromRts: () => {},
        handleSendPasswordEvent: () => {},
        handleGTLEmailStep: () => {},
        handleGTLCheckoutOption: () => {},
        handleGTLError: () => {},
        handleProductPopupOpened: () => {},
        handleProductPopupClosed: () => {},
        handleMinicartPopoverStatusEvent: () => {},
        handleRTSPopupClosedEvent: () => {},
        currencyCode: () => {},
        handleClickBannerEvent: () => {},
        handleRTSPopupWithDataClosedEvent: () => {},
        handleDigitalLightRegistration: () => {},
        handleGiftOptionStartEvent: () => {},
        handleGiftOptionAbortEvent: () => {},
        handleGiftOptionConfirmEvent: () => {},
        handleNoSearchResult: () => {},
        handleStoryImpressions: () => {},
        handleStoryImpressionClick: () => {},
        handleShareWishlistEvent: () => {},
        handleCameraLoad: () => {},
        handleClickRemoveFromWishlist: () => {},
        handleNotifyMeClick: () => {},
    };
}

export function registerHandlers(handlers) {
    for (const handlerName in handlers) {
        if (handlers[handlerName]) {
            window.__analyticHandlers[handlerName] = handlers[handlerName];
        }
    }
}

export default window.__analyticHandlers;
